import { Page } from '@hub/app/layout/Page';
import { QuickActionStatusProvider } from '@hub/app/quick-action-status';
import { StepUpProvider, useAuth } from '@hub/auth';
import { Outlet, useMatches } from '@hub/router';
import { AppShell } from './AppShell';
import { DomainShellContributions } from './DomainShellContributions';

export function AuthLayout() {
  return (
    <StepUpProvider>
      {/* Above the shell: a contribution publishes markers the outlet below reads. */}
      <QuickActionStatusProvider>
        <AppShell>
          <DomainShellContributions />
          <PageRouteOutlet />
        </AppShell>
      </QuickActionStatusProvider>
    </StepUpProvider>
  );
}

/**
 * Wraps `<Outlet />` in `<Page>` when the leaf route declares `staticData.title`
 * (the convention `definePageRoute` sets). Routes that opt into `customLayout`
 * — or that don't go through `definePageRoute` at all — render bare and own
 * their `<Page>`-or-equivalent chrome themselves.
 *
 * Dynamic chrome props (currently `hideBack`) are computed here from a `ctx`
 * snapshot that includes the auth state, so manifests stay declarative and
 * pure (no hooks at the route-definition site).
 */
function PageRouteOutlet() {
  const auth = useAuth();
  const staticData = useMatches({ select: (matches) => matches.at(-1)?.staticData ?? null });

  const title = staticData?.title?.();
  if (!title || staticData?.customLayout) {
    return <Outlet />;
  }

  return (
    <Page
      title={title}
      description={staticData?.description?.()}
      hideBack={staticData?.hideBack?.({ auth })}
      backFallback={staticData?.backFallback}
      backBehavior={staticData?.backBehavior}
    >
      <Outlet />
    </Page>
  );
}
